import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpdateAppScenario(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $updates: ScenarioUpdates!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          updateScenario(id: $scenarioId, updates: $updates) {
            id
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateAppScenarioMutation,
  void,
  graphql.schema.UpdateAppScenarioMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
